import type { AsyncReducerState } from '@helpers/makeReducer'
import makeReducer, {
  asyncReducer,
  INITIAL_ASYNC_REDUCER_STATE,
} from '@helpers/makeReducer'

import types from '../types'

export default makeReducer<AsyncReducerState>(
  INITIAL_ASYNC_REDUCER_STATE,
  asyncReducer({
    types: {
      pending: types.SET_PASSWORD_PENDING,
      fulfilled: types.SET_PASSWORD_FULFILLED,
      rejected: types.SET_PASSWORD_REJECTED,
    },
    // setUserData can reject after SET_PASSWORD_FULFILLED already set success=true.
    // Reset it so CallToAction's `loading || success` gate drops the spinner and
    // re-enables the field; the user can then retry.
    parseError: () => ({ success: null }),
  })
)
